// extracted by mini-css-extract-plugin
module.exports = {"alertBox":"alert_alertBox__2tgai","primary":"alert_primary__v6Z9s","secondary":"alert_secondary__GaaYM","tertiary":"alert_tertiary__E0jFz","small":"alert_small__1BPpa"};